export default "__VITE_ASSET__c001ebdf__"